import {ChangeDetectionStrategy, Component, computed, Injectable, input, ViewChild} from "@angular/core";
import {KommentarId, KommentarModell, SvarId, SvarModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {TranslateModule} from "@ngx-translate/core";
import {AvatarKomponent} from "web-ng2/delt/komponenter/avatar/avatar";
import {MatTooltip} from "@angular/material/tooltip";
import {kommentarerKunPublisertAv, varsledeEksTrådForfatter} from "felles-ng2/modell/kommentarModellHjelpere";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {NyttKommentarSvarKomponent} from "../nytt-kommentar-svar/nytt-kommentar-svar";
import {KommentarDatatjeneste} from "felles-ng2/tjenester/datalager/KommentarDatatjeneste";
import {AsyncPipe, NgClass, NgTemplateOutlet} from "@angular/common";
import {KlikkbareLenkerPipe} from "felles-ng2/pipes/KlikkbareLenkerPipe";
import {BekreftKlikkDirektiv} from "web-ng2/delt/direktiver/button--bekreftKlikk/button--bekreftKlikk";
import {FormaterZonedDateRelativTimePipe} from "felles-ng2/pipes/FormaterZonedDateTimeRelativPipe";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";

const debug = initDebugger('KommentarTraadKomponent');

@Component({
    selector: 'kommentar-traad',
    templateUrl: 'kommentar-traad.html',
    styleUrl: 'kommentar-traad.scss',
    host: { 'class': 'e2e-kommentartråd' },
    imports: [
        NgClass,
        NgTemplateOutlet,
        MatIcon,
        MatIconButton,
        MatMenu,
        MatMenuItem,
        MatTooltip,
        MatMenuTrigger,
        TranslateModule,
        AsyncPipe,
        KlikkbareLenkerPipe,
        FormaterZonedDateRelativTimePipe,
        AvatarKomponent,
        NyttKommentarSvarKomponent,
        BekreftKlikkDirektiv
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KommentarTraadKomponent {

    @ViewChild(NyttKommentarSvarKomponent) private svarKomponent: NyttKommentarSvarKomponent|null = null;

    traad = input.required<KommentarModell>();

    varsledeEksTraadForfatter = computed(() => varsledeEksTrådForfatter(this.traad()));
    erForfatter = computed(() => this.traad().publisertAv.brukerId == this.autentisertBrukersId());
    kanEndreTilPrivat = computed(()=> kommentarerKunPublisertAv(this.traad(), this.autentisertBrukersId()));
    endreTilPrivatTooltip = computed(()=> this.kanEndreTilPrivat() ?
      this.oversettelser.oversett(i18n('Gjør kommentaren kun synlig for deg')) :
      this.oversettelser.oversett(i18n('Kommentaren kan ikke gjøres privat da andre brukere har lagt til kommentarer på den')));

    constructor(private avhengigheter: KommentarTraadKomponentAvhengigheter, private oversettelser:Oversettelser, private kontekst: BrukerkontekstTilbyder) {
    }

    fokuserSvarfelt() {
        this.svarKomponent?.giFokus();
    }

    gjoerPrivat(privat: boolean) {
        this.avhengigheter.gjørPrivat(this.traad().id, privat);
    }

    slettTraad() {
        this.avhengigheter.slettTråd(this.traad().id);
    }

    kanSletteSvar(svar: SvarModell) {
        return svar.publisertAv.brukerId == this.autentisertBrukersId();
    }

    slettSvar(svar: SvarModell) {
        this.avhengigheter.slettSvar(this.traad().id, svar.id);
    }

    //private hjelpemetoder

    private autentisertBrukersId() {
        return this.kontekst.autentisertBruker().bruker.id;
    }
}

@Injectable()
export class KommentarTraadKomponentAvhengigheter {

    constructor(private kommentarDatatjeneste: KommentarDatatjeneste) {
    }

    async gjørPrivat(id: KommentarId, privat: boolean): Promise<void> {
        await this.kommentarDatatjeneste.gjørPrivat(id, privat);
    }

    async slettTråd(id: KommentarId): Promise<void> {
        await this.kommentarDatatjeneste.slettKommentar(id);
    }

    async slettSvar(id: KommentarId, svarId: SvarId): Promise<void> {
        await this.kommentarDatatjeneste.slettSvar(id, svarId);
    }
}
